import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const styles = (theme) => ({
  wrap: {
    width: '100%',
  },
  card: {
    borderRadius: 12,
    overflow: 'hidden',
    background: theme.palette.background.paper,
    boxShadow: '0 12px 28px rgba(0,0,0,0.08)',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
      boxShadow: 'none',
    },
  },
  img: {
    display: 'block',
    width: '100%',
    height: 'auto',
    /* MOBİL: ekrana tam otur, taşma yok */
    [theme.breakpoints.down('sm')]: {
      width: '100vw',         // viewport genişliği kadar
      maxWidth: '100vw',
      marginLeft: 'calc(50% - 50vw)', // kapsayıcıda padding olsa bile ortala
    },
  },
});

const DashboardHome = ({ classes }) => (
  <div className={classes.wrap}>
    <Paper className={classes.card} elevation={0}>
      <img
        src="static/images/dashboard.jpg"
        alt="Dashboard"
        className={classes.img}
        loading="lazy"
        decoding="async"
        sizes="100vw"
      />
    </Paper>
  </div>
);

export default withStyles(styles)(DashboardHome);
